module.exports = __webpack_public_path__ + "img/3-6.28ff7523.png";